import { render } from "./QuestionInfoButton.vue?vue&type=template&id=20d5e6e9"
import script from "./QuestionInfoButton.vue?vue&type=script&lang=js"
export * from "./QuestionInfoButton.vue?vue&type=script&lang=js"

import "./QuestionInfoButton.vue?vue&type=style&index=0&id=20d5e6e9&lang=css"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__